import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import {faAt, faDollarSign} from "@fortawesome/pro-regular-svg-icons";
import ChangeAccountEmailForm from "./ChangeAccountEmailForm";


const ChangeAccountEmailButton = ({userAccount}) => {
    const [showDialog, setShowDialog] = React.useState(false);

    return (
        <React.Fragment>
            <Button
                color="primary"
                onClick={handleOpen}
                variant={'text'}
                // size={'small'}
            >
                <FontAwesomeIcon
                    icon={faAt}
                    fixedWidth
                />
                &nbsp;Update Email
            </Button>

            <Dialog
                open={showDialog}
                onClose={handleClose}
                aria-labelledby="jeff-credit-dialog-title"
                aria-describedby="jeff-credit-description"
                maxWidth={'md'}
                fullWidth={true}
            >
                <DialogTitle id="account-dialog-title">Change Email</DialogTitle>
                <DialogContent>
                    <ChangeAccountEmailForm
                        accountUID={userAccount.account_uid}
                        currentEmail={userAccount.email_address}
                        doneCallback={handleClose}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );

    function handleOpen() {
        setShowDialog(true);
    }

    function handleClose() {
        setShowDialog(false);
    }
};


export default ChangeAccountEmailButton;